import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import CreditCardForm from '../../molecules/CreditCardForm';
import {CREDIT_CARD_PAYMENT_METHODS} from '../../../consts';

const CreditCardSection = ({
    showCancelButton,
    maskedCardNumber,
    translations,
    isSubmitting,
    genericError,
    onSubmit,
    languageCode
}) => {
    const cardMaskedPan = maskedCardNumber.replaceAll('X', '*');

    useEffect(() => {
      document.getElementById('cvv-creditcard')?.focus();
    });

    return (
        <div className="cybersource-card-section">
            <div className="cybersource-card-section-inner">
                <h2 className="card-masked-pan">{cardMaskedPan}</h2>
                <h2 className="card-heading">{translations.creditCard.popUp.heading}</h2>
                <h4 className="card-description">{translations.creditCard.popUp.cvv}</h4>
            </div>

            <CreditCardForm
                showCancelButton={showCancelButton}
                disableSubmitButton={Boolean(isSubmitting || genericError)}
                translations={translations}
                onSubmit={onSubmit}
                genericError={genericError}
                languageCode={languageCode}
                paymentMethod={CREDIT_CARD_PAYMENT_METHODS.CYBERSOURCE}
            />
        </div>
    );
};

CreditCardSection.propTypes = {
    maskedCardNumber: PropTypes.string.isRequired,
    translations: PropTypes.shape({
        common: PropTypes.shape({
            continue: PropTypes.string.isRequired,
            cancel: PropTypes.string.isRequired
        }).isRequired,
        creditCard: PropTypes.shape({
            popUp: PropTypes.shape({
                heading: PropTypes.string.isRequired,
                cvv: PropTypes.string.isRequired,
                warningText: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    }).isRequired,
    isSubmitting: PropTypes.bool,
    genericError: PropTypes.bool,
    onSubmit: PropTypes.func,
    languageCode: PropTypes.string.isRequired,
    showCancelButton: PropTypes.bool
};

CreditCardSection.defaultProps = {
    showCancelButton: false,
    isSubmitting: false,
    genericError: null,
    onSubmit: () => {}
};

export default CreditCardSection;
